import { render, staticRenderFns } from "./AddressConfirmation.vue?vue&type=template&id=f9028498&scoped=true&"
import script from "./AddressConfirmation.vue?vue&type=script&lang=js&"
export * from "./AddressConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./AddressConfirmation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddressConfirmation.vue?vue&type=style&index=1&id=f9028498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9028498",
  null
  
)

export default component.exports